import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { metadata, proofPoints } from '../data/data';
import { staggerContainer, fadeInUp, fadeInRight } from '../lib/motion';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="min-h-screen flex items-center bg-[#f8f8f6] pt-24">
      <div className="container-editorial w-full">
        <div className="grid grid-cols-12 gap-y-8 lg:gap-x-8">
          {/* Left column - Hero content */}
          <motion.div
            className="col-span-12 lg:col-span-7"
            variants={staggerContainer}
            initial="initial"
            animate="animate"
          >
            {/* <motion.p
              variants={fadeInUp}
              className="text-sm uppercase tracking-widest text-[#666666] mb-6"
              style={{ fontFamily: 'var(--font-sans)' }}
            >
              Portfolio 2026
            </motion.p> */}

            <motion.h1
              variants={fadeInUp}
              className="text-7xl lg:text-8xl font-normal leading-[0.95] mb-8 text-[#1a1a1a]"
              style={{ fontFamily: 'var(--font-serif)' }}
            >
              {metadata.name}
            </motion.h1>

            <motion.div
              variants={fadeInUp}
              className="w-16 h-[1px] bg-[#8B4513] mb-8"
            />

            <motion.p
              variants={fadeInUp}
              className="text-2xl text-[#1a1a1a] mb-4 max-w-xl leading-relaxed"
              style={{ fontFamily: 'var(--font-sans)', fontWeight: 300 }}
            >
              {metadata.role}
            </motion.p>

            <motion.p
              variants={fadeInUp}
              className="text-base text-[#666666] mb-12 max-w-lg leading-relaxed"
              style={{ fontFamily: 'var(--font-sans)' }}
            >
              {metadata.description}
            </motion.p>

            <motion.button
              variants={fadeInUp}
              onClick={() => scrollToSection('projects')}
              className="group inline-flex items-center gap-3 text-[#1a1a1a] border-b border-[#1a1a1a] pb-1 hover:border-[#8B4513] hover:text-[#8B4513] transition-all duration-300"
              style={{ fontFamily: 'var(--font-sans)', fontSize: '14px', letterSpacing: '0.05em', textTransform: 'uppercase' }}
              whileHover={{ x: 2 }}
            >
              View Selected Work
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </motion.button>
          </motion.div>

          {/* Right column - Proof points */}
          <motion.div
            className="col-span-12 lg:col-span-4 lg:col-start-9"
            variants={staggerContainer}
            initial="initial"
            animate="animate"
          >
            <div className="space-y-6 pt-8">
              {proofPoints.map((point, index) => (
                <motion.div
                  key={index}
                  variants={fadeInRight}
                  className="border-l border-[#d4d4d0] pl-4"
                  whileHover={{ x: 4, transition: { duration: 0.2 } }}
                >
                  <p className="text-sm text-[#666666]" style={{ fontFamily: 'var(--font-sans)' }}>
                    {point}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;